import React from 'react';

export default function AttributeSetTable({ attributeSets, onAttributeSelect }) {
	return (
		<div className="table-view table-responsive" id="setting-tables">
			<table id="attribute-set-table" className="table">
				<thead>
					<tr>
						<th>Attribute Set Name</th>
						<th>Type</th>
						<th style={{ textAlign: 'right' }}>Number Of Records</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{attributeSets
						? attributeSets.map(attribute => (
								<tr key={attribute.id}>
									<td>{attribute.attributeSetName}</td>
									<td>{attribute.type}</td>
									<td>0</td>
									<td>
										<i
											data-toggle="modal"
											data-target="#confirmationModal"
											className="fa fa-trash-o icon"
											onClick={() => onAttributeSelect(attribute)}
										/>
										<i
											data-toggle="modal"
											data-target="#twoInputEditModal"
											className="fa fa-pencil-square-o icon"
											onClick={() => onAttributeSelect(attribute)}
										/>
									</td>
								</tr>
						  ))
						: null}
				</tbody>
			</table>
		</div>
	);
}
